<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 14:13:38
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalType\ApprovalType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-approval-type')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :height="$vuetify.breakpoint.height - 275"
        :items="desserts"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.flow_type_name)"
          >
            {{ $getCommonLangValue(item.flow_type_name) }}
          </div>
          <!-- <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.flow_type_description) }}
          </div> -->
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-approval-type')"
            :editBtn="hasBtn('edit-admin-approval-type')"
            :viewBtn="hasBtn('view-admin-approval-type')"
            :title="$t('label_essweb_approvalType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ApprovalType",
  computed: {},
  data() {
    return {
      showSelect: false,
      showDelete: false,
      selected: [],
      search: "",
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_approvalType_list_approvalTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.flow_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/get-approval-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/approval-type/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/approval-type/edit/"
          : "/admin/approval-type/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.showDelete = false;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/delete-approval-type-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalType_list_deleteApprovalTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
